import {faker}  from "@faker-js/faker";

import { getOrgApp } from "../helpers/get-orgApp";
import { getSelectedDepartmentFromAccount } from "../helpers/get-accounts";

var names = [
  "Application-Golden",
  "Application-Production-Test",
  "Application-Production-Golden",
  "Application-Repro-Test",
  "Application-Production-Test",
];

var regionCodes = [
  "us-east-1",
  "us-east-2",
  "us-west-1",
  "us-west-2",
  "ap-south-1",
];

export const allImages = async (imageCount, accountList, regionList) => {
  let images = [];
  let orgAppDetails = await getOrgApp();
  let selectedDepartments = [];
  if (accountList && accountList.length > 0) {
    selectedDepartments = getSelectedDepartmentFromAccount(
      orgAppDetails,
      accountList
    );
  }
  for (var i = 0; i < imageCount; i++) {
    let selectedOrg = faker.helpers.arrayElement(orgAppDetails);
    let selectedDept = faker.helpers.arrayElement(
      selectedDepartments && selectedDepartments.length > 0
        ? selectedDepartments
        : selectedOrg.depts
    );
    let selectedDeptApp = faker.helpers.arrayElement(selectedDept.deptApps);
    let selectedDeptAccount = faker.helpers.arrayElement(
      selectedDept.deptAccounts
    );
    const resouceName =
      selectedDept.deptCode +
      "-" +
      faker.helpers.arrayElement(names) +
      "-" +
      selectedDeptApp.appEnv +
      "-AMI";

    const RegionCode =
      regionList && regionList.length
        ? faker.helpers.arrayElement(regionList)
        : faker.helpers.arrayElement(regionCodes);

    var image = {
      ARN: `arn:aws::image:${RegionCode}:${faker.random.alphaNumeric(15)}`,
      ResourceName: resouceName,
      ResourceId: "ami-" + faker.random.alphaNumeric(15),
      Hypervisor: "xen",
      Public: faker.random.boolean(),
      EnaSupport: faker.random.boolean(),
      SriovNetSupport: "simple",
      ImageLocation: selectedDeptAccount.accountNumber,
      Owner: selectedDeptAccount.accountNumber,
      OwnerId: selectedDeptAccount.accountNumber,
      OwnerAccountNumber: selectedDeptAccount.accountNumber,
      RegionCode,
      AccountNumber: selectedDeptAccount.accountNumber,
      OrganizationId: selectedOrg.orgId,
      ApplicationId: selectedDeptApp && selectedDeptApp.appId,
      DepartmentId: selectedDept.deptId,
      EnvironmentId: selectedDeptApp && selectedDeptApp.appEnvId,
      State: "available",
      Metadata: {
        CreationDate: "2017-11-30T03:25:02.000Z",
        Architecture: "x86_64",
        RootDeviceName: "/dev/xvda",
        ImageType: "machine",
        VirtualizationType: "hvm",
        RootDeviceType: "ebs",
        BlockDeviceMappings: [
          {
            DeviceName: "/dev/xvda",
            Ebs: {
              Encrypted: false,
              DeleteOnTermination: true,
              VolumeType: "gp2",
              VolumeSize: 8,
              SnapshotId: "snap-0870847ab91ffa0b4",
            },
          },
        ],
      },
    };
    image.Tags = [
      {
        Key: "Name",
        Value: image["Name"],
      },
    ];
    image.Description = image["Name"];
    images.push(image);
  }
  return images;
};
